/**
 * Campaign NPC Types
 *
 * Campaign-scoped NPCs that the GM can customize, track, and manage.
 * Each NPC is a Supabase row, optionally linked to static FactionNpc lore.
 */
import { z } from 'zod';
import { FactionRoleSchema } from './faction-types';
// =============================================================================
// NPC STATUS
// =============================================================================
export const NpcStatusSchema = z.enum(['active', 'inactive', 'dead', 'missing', 'allied']);
// =============================================================================
// CAMPAIGN NPC
// =============================================================================
export const CampaignNpcSchema = z.object({
    id: z.string().uuid(),
    campaignId: z.string().uuid(),
    name: z.string(),
    title: z.string().optional(),
    description: z.string(),
    factionId: z.string().optional(),
    factionNpcId: z.string().optional(),
    role: FactionRoleSchema.optional(),
    districtId: z.string().optional(),
    currentLocation: z.string().optional(),
    isKeystone: z.boolean().default(false),
    status: NpcStatusSchema.default('active'),
    disposition: z.string().optional(),
    dialogueHints: z.array(z.string()).default([]),
    gmNotes: z.string().default(''),
    lastMentionedAt: z.string().optional(),
    isSecret: z.boolean().default(false),
    createdAt: z.string().optional(),
    updatedAt: z.string().optional(),
});
//# sourceMappingURL=npc-types.js.map